import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { ChevronRight } from "react-feather";

import {
  postPreview,
  postPreviewImage,
  postPreviewTitle,
  postPreviewDate,
  postPreviewExcerpt,
  postPreviewSummary,
  postPreviewLink,
} from "./styles.module.css";

const PostPreview = ({ post }) => {
  const { node } = post || {};
  const { frontmatter, excerpt, fields } = node || {};
  const { title, date, featured_image: featuredImage } = frontmatter || {};

  return (
    <div className={postPreview}>
      <img
        className={postPreviewImage}
        src={featuredImage}
        alt={postPreviewTitle}
      />
      <div className={postPreviewSummary}>
        <h2 className={postPreviewTitle}>{title}</h2>
        <p className={postPreviewDate}>{date}</p>
        <p className={postPreviewExcerpt}>{excerpt}</p>
        <Link to={fields.slug} className={postPreviewLink}>
          Read More...
        </Link>
      </div>
    </div>
  );
};

export default PostPreview;
